import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import { FormDiscountReason } from "./FormDiscountReason";

export function NewDiscountReason({ ...props }) {

   return (
      <CadastroContainer>
         <FormDiscountReason />
      </CadastroContainer>
   );
}